module.exports = __webpack_public_path__ + "static/media/hest-lyn.dd7602c8.png";